import "./set-webpack-public-path";
import Editor from "./vb-django/components/editor/Editor";
import PuckPageView from "./vb-django/components/editor/PuckPageView";
import { initializeReactApp, withSentryUserData, wrapWithLoginPopup, wrapWithSubscriptionCheckout } from "./entry-helper";

const components = {
    Editor: wrapWithLoginPopup(withSentryUserData(Editor)),
    PuckPageView: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(PuckPageView))),
};

initializeReactApp({
    componentName: null,
    componentFactory: (name) => components[name],
    skipComponents: [],
})